
















































































import { Observer } from "mobx-vue";
import { Component, Vue } from "vue-property-decorator";
import RequestStatusIcon from "@/components/Requests/RequestStatusIcon.vue";
import RequestTaskStatusIcon from "@/components/Requests/RequestTaskStatusIcon.vue";
import ButtonImageCarousel from "../ExpandableImage/ButtonImageCarousel.vue";
import { isTaskUnsuccessful } from "@/api/Requests";
import mapStore from "@/store/mapStore";
import FormattedAddress from "@/components/Address/FormattedAddress.vue";
import { datetimeExact, dateDayExact } from "@/filters/DateExact";

@Observer
@Component({ components: { RequestTaskStatusIcon, RequestStatusIcon, ButtonImageCarousel, FormattedAddress } })
class RequestSummary extends Vue {
  mapStore = mapStore;
  isTaskUnsuccessful = isTaskUnsuccessful;

  formatDatetimeExact(date: string | Date | undefined) {
    if (!date) return "";
    const iso = date instanceof Date ? date.toISOString() : date;
    return datetimeExact(iso);
  }

  formatDateDayExact(date: string | Date | null | undefined) {
    if (!date) return "";
    const iso = date instanceof Date ? date.toISOString() : date;
    return dateDayExact(iso);
  }
}

export default RequestSummary;
